<div style="position: relative">
  <div #wrapperFilterHeader style="display: inline-block; width: 100%">
    <lib-filter-header
      #ixFilterItemHeader
      [label]="this.label"
      [valueAll]="this.valueAll"
      [value]="this.value"
      [divFocusClass]="this.filterItemHeaderDivFocusClass"
      [activeAngleDown]="!!op1?.overlayVisible"
      [angleDefaultAction]="
        !(
          this.advancedFieldOd ||
          this.advancedFieldDo ||
          advancedFieldMnozicaElem ||
          advancedFieldObstaja
        )
      "
      [showDropdownButton]="
        !!(
          this.advancedFieldOd ||
          this.advancedFieldDo ||
          advancedFieldMnozicaElem ||
          advancedFieldObstaja
        )
      "
      [isFocusOn]="this.focusFilterItemHeader"
      (ixClick)="this.onFilterToggle($event)"
      (ixClickDown)="this.onClickDown($event)"
    />
  </div>

  <div
    tabindex="0"
    class="simple-filter-input CssAbsoluteFull"
    [style.display]="this.isOpen ? 'inline-flex' : 'none'"
    [formGroup]="getFormGroupForDiv()"
    (keydown.enter)="this.onFilterToggle($event, 'enter')"
    (keydown.tab)="this.onFilterToggle($event)"
    (focusout)="this.isOpen && this.onFilterToggle($event)"
  >
    @if (!mask || mask === '') {
      <ix-input
        #input
        field="field"
        style="
          display: inline-block;
          flex-grow: 1;
          max-width: 100%;
          vertical-align: top;
          padding-left: 5px;
          margin-top: -3px;
          padding-right: 10px;
          justify-content: center;
        "
        [ixFormGroup]="this.ixFormGroupUtil?.ixFormGroup"
        [readOnlyForce]="false"
        [pattern]="this.pattern"
        [patternMessage]="this.patternMessage"
        [maxLength]="this.maxLength"
        (ixChange)="this.onStringChange($event)"
        (escape)="focusHeader()"
        (keyup.alt.f9)="this.inputToggleWindow($event)"
        (toggleWindow)="this.inputToggleWindow($event); focusHeader()"
      />
    }

    @if (mask && mask !== '') {
      <ix-input-mask
        #inputMask
        field="field"
        style="display: inline-block; flex-grow: 1"
        [ixFormGroup]="this.ixFormGroupUtil?.ixFormGroup"
        [mask]="this.mask || ''"
        [readOnlyForce]="false"
        (ixChange)="this.onStringChange($event)"
        (escape)="focusHeader()"
        (toggleWindow)="
          inputMask.inputMask?.el?.nativeElement?.children[0].trigger('click'); focusHeader()
        "
      />
    }
  </div>
</div>

<p-popover
  #op1
  ixOverlay
  class="CssFilterOverlayPanel"
  [appendTo]="this.appendTo"
  (onHide)="this.onHide()"
>
  <ng-template #content>
    <div style="min-width: 400px" (keydown)="onKeydown($event)" tabindex="0">
      <!--Search mode-->

      <p-tabs
        class="CssIxTabView"
        [ngClass]="{
          CssIxTabViewHidden: !(
            (this.advancedFieldOd !== undefined && this.advancedFieldDo !== undefined) ||
            this.advancedFieldMnozicaElem !== undefined ||
            this.advancedFieldObstaja !== undefined
          ),
        }"
        [value]="this.searchMode"
        (valueChange)="this.onSearchMode($event)"
      >
        <p-tablist>
          @if (this.advancedFieldOd !== undefined && this.advancedFieldDo !== undefined) {
            <p-tab [value]="'advancedFieldOdDo'">Od-Do</p-tab>
          }
          @if (this.advancedFieldMnozicaElem !== undefined) {
            <p-tab [value]="'advancedFieldMnozicaElem'">Seznam</p-tab>
          }
          @if (this.advancedFieldObstaja !== undefined) {
            <p-tab [value]="'advancedFieldObstaja'">Obstaja</p-tab>
          }
          @if (this.advancedFieldNapredno !== undefined) {
            <p-tab [value]="'advancedFieldNapredno'">Napredno</p-tab>
          }
          <div
            class="p-tab"
            style="
              display: flex;
              width: 15px;
              justify-content: center;
              background: transparent;
              cursor: default;
            "
          >
            @if (this.showHelpIcon) {
              <a
                class="CssTopBar"
                href="#"
                style="margin: auto"
                (click)="this.showHelpVnosniNiz($event)"
              >
                <i class="topbar-icon pi pi-fw pi-question-circle"></i>
                <span class="topbar-item-name">Help</span>
              </a>
            }
          </div>
          @if (this.showCloseIcon) {
            <div
              class="p-tab"
              style="display: flex; width: 15px; justify-content: center"
              (click)="this.op1?.hide()"
              (keyup.enter)="this.op1?.hide()"
              tabindex="0"
            >
              <i pButtonIcon class="pi pi-times"></i>
            </div>
          }
        </p-tablist>

        <p-tabpanels style="padding: 5px">
          @if (this.advancedFieldOd !== undefined && this.advancedFieldDo !== undefined) {
            <p-tabpanel id="advancedFieldOdDo" [value]="'advancedFieldOdDo'">
              @if (!mask || mask === '') {
                <ix-input
                  #advancedFieldOdComponent
                  label="Od"
                  field="advancedFieldOd"
                  style="width: 100%; display: block"
                  [ixFormGroup]="this.ixFormGroupUtil?.ixFormGroup"
                  [placeholder]="this.advancedFieldOdDoPlaceholder"
                  [readOnlyForce]="false"
                  (ixChange)="this.onStringChange($event, true)"
                />
              }
              @if (!mask || mask === '') {
                <ix-input
                  #advancedFieldDoComponent
                  label="Do"
                  field="advancedFieldDo"
                  style="width: 100%; display: block"
                  [ixFormGroup]="this.ixFormGroupUtil?.ixFormGroup"
                  [placeholder]="this.advancedFieldOdDoPlaceholder"
                  [readOnlyForce]="false"
                  (ixChange)="this.onStringChange($event, true)"
                />
              }
              @if (mask && mask !== '') {
                <ix-input-mask
                  #advancedFieldOdComponent
                  label="Od"
                  field="advancedFieldOd"
                  style="width: 100%; display: block"
                  [ixFormGroup]="this.ixFormGroupUtil?.ixFormGroup"
                  [readOnlyForce]="false"
                  [mask]="this.mask || ''"
                  (ixChange)="this.onStringChange($event, true)"
                  (escape)="this.onStringChange($event, true)"
                />
              }
              @if (mask && mask !== '') {
                <ix-input-mask
                  #advancedFieldDoComponent
                  label="Do"
                  field="advancedFieldDo"
                  style="width: 100%; display: block"
                  [ixFormGroup]="this.ixFormGroupUtil?.ixFormGroup"
                  [readOnlyForce]="false"
                  [mask]="this.mask || ''"
                  (ixChange)="this.onStringChange($event, true)"
                  (escape)="this.onStringChange($event, true)"
                />
              }
            </p-tabpanel>
          }

          @if (this.advancedFieldMnozicaElem !== undefined) {
            <p-tabpanel id="advancedFieldMnozicaElem" [value]="'advancedFieldMnozicaElem'">
              @if (this.advancedFieldMnozicaElemIn) {
                <ix-boolean
                  #advancedFieldMnozicaElemInComponent
                  field="advancedFieldMnozicaElemIn"
                  onLabel="Je v seznamu"
                  offLabel="Ni v seznamu"
                  [ixFormGroup]="this.ixFormGroupUtil?.ixFormGroup"
                  [class.padding-bottom]="true"
                  [readOnlyForce]="false"
                  (ixChange)="this.onStringChange($event, true)"
                />
              }
              <ix-text-area
                #advancedFieldMnozicaElemComponent
                label=""
                field="advancedFieldMnozicaElem"
                style="width: 100%; display: block"
                [ixFormGroup]="this.ixFormGroupUtil?.ixFormGroup"
                [placeholder]="this.advancedFieldMnozicaElemPlaceholder"
                [readOnlyForce]="false"
                [rows]="5"
                (ixChange)="this.onStringChange($event, true)"
              />
            </p-tabpanel>
          }

          @if (this.advancedFieldObstaja !== undefined) {
            <p-tabpanel id="advancedFieldObstaja" [value]="'advancedFieldObstaja'">
              <ix-boolean
                #advancedFieldObstajaComponent
                field="advancedFieldObstaja"
                onLabel="Vrednost je vpisana"
                offLabel="Vrednost ni vpisana"
                [ixFormGroup]="this.ixFormGroupUtil?.ixFormGroup"
                [readOnlyForce]="false"
                (ixChange)="this.onStringChange($event, true)"
              />
            </p-tabpanel>
          }
          @if (this.advancedFieldNapredno !== undefined) {
            <p-tabpanel id="advancedFieldNapredno" [value]="'advancedFieldNapredno'">
              <ix-text-area
                #advancedFieldNaprednoComponent
                label=""
                field="advancedFieldNapredno"
                style="width: 100%; display: block"
                [ixFormGroup]="this.ixFormGroupUtil?.ixFormGroup"
                [placeholder]="this.advancedFieldNaprednoPlaceholder"
                [readOnlyForce]="false"
                [style.max-width]="this.getValueFromStylePanel('max-width')"
                [rows]="5"
                (ixChange)="this.onStringChange($event, true)"
              />
            </p-tabpanel>
          }
        </p-tabpanels>
      </p-tabs>
    </div>
  </ng-template>
</p-popover>
